module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper rating-wrapper"
  }, [_c('div', {
    staticClass: "watch-again"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "current-video-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentVideo.img,
      "alt": _vm.currentVideo.title
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "congratz"
  }, [_vm._v("Congrats! You learned a new lorem ipsum dolor sit amet today")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-link"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-play"
  }), _vm._v("    watch again\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "rating"
  }, [_c('ul', {
    staticClass: "chart-skills"
  }, [_c('li', [_c('span', [_vm._v("Rating 1")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rating 2")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rating 3")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rating 4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Use these 7 Tips to Climb the Corporate Ladder")]), _vm._v(" "), _c('p', [_vm._v("\n                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\n                        been the industry's standard dummy text ever since the 1500s, when an unknown printer took a\n                        galley of type and scrambled it to make a type specimen book. It has survived not only five\n                        centuries, but also the leap into electronic typesetting, remaining essentially unchanged.\n                        It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum\n                        passages, and more recently with desktop publishing software like Aldus PageMaker including\n                        versions of Lorem Ipsum\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "recently-watched"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg"
  }, [_vm._v("View Transcript")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "authorContent"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/live-event-two.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Joelle K. Jay")]), _vm._v(" "), _c('h5', [_vm._v("Author, CEO")])]), _vm._v(" "), _c('p', [_vm._v("\n                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\n                            been the industry's standard dummy text ever\n                        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720807f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Rating.vue